import React from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
// import { useNavigate } from "react-router-dom";
import LogoImg from "../../images/logos/logo.jpg";
import { Link as LinkR } from "react-router-dom";
import { Navigate } from "react-router-dom/dist";

//brand logo container controller size
const BrandLogoContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 5%;
  /* height: 80%; */
  width: 20%;

  /* &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 25%;
    right: 0;
    height: 2px;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) -3.92%,
      rgba(0, 0, 0, 0.25) 45.17%
    );
  } */

  @media screen and (max-width: ${deviceSize.mobile}px) {
    padding-left: 0;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: ${({ mmlsize }) => (mmlsize ? mmlsize + "px" : "10px")};
    padding-bottom: ${({ pmsize }) => (pmsize ? pmsize + "px" : "0px")};
  }
`;

// logo image props
const LogoImage = styled.div`
  width: ${({ lwsize }) => (lwsize ? lwsize + "px" : "79px")};
  height: ${({ lhsize }) => (lhsize ? lhsize + "px" : "34px")};
  left: 59px;
  top: 46px;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    margin-left: 8px;
    margin-top: 8px;

    img {
      width: 80%;
      height: 100%;
      margin-right: 14px;
    }
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
    margin-top: 0px;

    img {
      width: 80%;
      height: 100%;
      margin-right: 14px;
    }
  }
`;

//title of logo
const LogoTitle = styled.h3`
  /* absolute:absolute; */
  margin: 0;
  margin-left: 10px;
  font-size: ${({ size }) => (size ? size + "px" : "14px")};
  color: ${(props) => props.color};
  font-weight: 400;
  font-family: "bai jamjuree";
  text-transform: lowercase;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;

  @media screen and (max-width: ${deviceSize.laptop}px) {
    margin-left: 0px;
    white-space: nowrap;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    margin-left: -10px;
    margin-top: 8px;
    white-space: nowrap;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
    margin-top: 0px;
    white-space: nowrap;
  }
`;

const StyledLink = styled(LinkR)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    width: 60px;
  }
`;

const Img = styled.img`
  @media screen and (max-width: ${deviceSize.mmobile}px) {
    width: 64px;
  }
`;

//export of the logo and name to top of the website

export function BrandLogo(props) {
  const { lhsize, lwsize, textSize, color, hideLogo } = props;
  const { ptSize, hsize, wsize, mlsize, mmlsize, pmsize } = props;
  // const history = useNavigate();

  const handleLogoClick = () => {
    Navigate("/");
    window.scrollTo(0, 0);
  };

  return (
    <BrandLogoContainer
      mmlsize={mmlsize}
      mlsize={mlsize}
      size={ptSize}
      Wsize={wsize}
      Hsize={hsize}
      pmsize={pmsize}
    >
      {!hideLogo && (
        <StyledLink to="/" onClick={handleLogoClick}>
          <LogoImage lhsize={lhsize} wsize={lwsize}>
            <Img src={LogoImg} alt="Expedient Service logo" />
          </LogoImage>
          <LogoTitle size={textSize} color={color}>
          expedient
        </LogoTitle>
        </StyledLink>
      )}
    </BrandLogoContainer>
  );
}
